export default __webpack_public_path__ + "static/Hepatofelin-desktop-xl-a865db768b248dfbb8f47f8b53633bcf.jpg";